module.exports = __webpack_public_path__ + "frontend/images/gold/carousel/live/live.png?79b72c657b6feb8688c6b96592a2510d";